import Usuario from "@/domain/conta/usuario/Usuario.js";
import Table from "./Table";
export default class TableUsuarios extends Table {
    constructor() {
        super();
    }

    getHeaders() {
        var headers;
        headers = [
            { text: "Ações", value: "acoes", show: true, pesq: false, enable: false },
            { text: "Nome", value: "nome", show: true, pesq: true, enable: true },
            { text: "Sobrenome", value: "sobrenome", show: true, pesq: false, enable: true },
            { text: "E-mail", value: "email", show: true, pesq: true, enable: true },
            { text: "Telefone", value: "telefone", show: true, pesq: false, enable: true },
            { text: "Data de Nascimento", value: "dtNascimento", show: true, pesq: false, enable: true },
            { text: "Estado", value: "estado", show: true, pesq: false, enable: true },
            { text: "Cidade", value: "cidade", show: true, pesq: false, enable: true },
            { text: "Status", value: "statusIn", show: true, pesq: false, enable: true },
            { text: "preCadastro", value: "preCadastro", show: false, pesq: false, enable: false },
            { text: "_id", value: "_id", show: false, pesq: false, enable: false },
        ]
        return headers
    }

    setNota(arrayNotas, notas) {

        this.loading = false;
        for (var i = 0; i < notas.length; i++) {
            if (notas[i].status) {
                arrayNotas.push(
                    new Usuario(
                        notas[i].colaborador.nome,
                        notas[i].colaborador.sobrenome,
                        notas[i].colaborador.email,
                        notas[i].colaborador.telefone,
                        notas[i].colaborador.dtNascimento,
                        notas[i].colaborador.estado,
                        notas[i].colaborador.cidade,
                        notas[i].status,
                        notas[i].colaborador.preCadastro,
                        notas[i].colaborador._id
                    )
                );
            }
            this.pagination.sortBy = 'nome';
            this.pagination.descending = false;
        }
        return arrayNotas
    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableUsuarios.js